import axios from 'axios';
import { useState } from 'react';
import Cookies from 'js-cookie';
import CONFIG from '../constanta/config';
import { useQuery } from '../hook/useQuery';

const CATEGORY_LIST = [
  'LOC Guyana',
  'Sponsor',
  'Speaker',
  'Invitee Ministerial',
  'Presenter Delegate',
  'Scientific Secretary',
  'CARPHA Staff Partner',
  'Invitee Special Guest',
  'Guyanese National',
  'Student',
  'NA',
  'Awardee',
  'Secretariat',
  'Special Rate',
  'Carpha Leadership'
];

const PRIVILEGES = [
  'Day 1',
  'Lunch 1',
  'Day 2',
  'Lunch 2',
  'Day 3',
  'Lunch 3',
  'Awards'
];

const PopupAddUserNew = (props) => {
  const query = useQuery();

  const [form, setForm] = useState({
    firstname: '',
    lastname: '',
    company: '',
    position: '',
    country: '',
    email: '',
    phone: '',
    category: '',
    access_privilege: []
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [msg, setMsg] = useState('');
  const [duplicate, setDuplicate] = useState({
    phone: false,
    email: false
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.id]: e.target.value });
    setErrors({ ...errors, [e.target.id]: '' });
  };

  const handleCheckbox = (value) => {
    let updated = [...form.access_privilege];

    if (updated.includes(value)) {
      updated = updated.filter((item) => item !== value);
    } else {
      updated.push(value);
    }

    setForm({ ...form, access_privilege: updated });
    setErrors({ ...errors, access_privilege: '' });
  };

  const generateRandom5Digit = () => {
    return Math.floor(10000 + Math.random() * 90000).toString();
  };

  const handleDuplicate = (field) => {
    setDuplicate((prev) => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  // ✅ VALIDASI SEMUA FIELD
  const validate = () => {
    let newErrors = {};

    Object.keys(form).forEach((key) => {
      if (
        (typeof form[key] === 'string' && !form[key].trim()) ||
        (Array.isArray(form[key]) && form[key].length === 0)
      ) {
        newErrors[key] = 'This field is required';
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = () => {
    setMsg('');

    if (!validate()) return;

    setLoading(true);

    let finalPhone = form.phone;
let finalEmail = form.email;

// 🔥 inject random jika duplicate dicentang
if (duplicate.phone && form.phone) {
  finalPhone = form.phone + generateRandom5Digit();
}

if (duplicate.email && form.email) {
  const random = generateRandom5Digit();
  finalEmail = `${random}_${form.email}`;
}

    const payload = {
      ...form,
      phone: finalPhone,
      email: finalEmail,
      access_privilege: form.access_privilege.join(', '),
      authorized_by: ' ',
      id_gate: query.get('id_gate')?.trim()
    };

    const form_data = new FormData();
    Object.keys(payload).forEach((key) => {
      form_data.append(key, payload[key]);
    });

    axios
      .post(CONFIG.URL + '/user/add', form_data, {
        headers: {
          token: Cookies.get('token')
        }
      })
      .then((res) => {
        if (res?.data?.status === 'SUCCESS') {
          setSuccess(true);
          setMsg('User successfully added');

          const data = res.data;

          axios
            .get(CONFIG.URL + '/user/' + data?.id, {
              headers: {
                token: Cookies.get('token')
              }
            })
            .then(function (response) {
              let formdata = response?.data?.data[0];
              if (response?.data.status === 'SUCCESS') {
                openInNewWindow(
                  `/printcode?name=${formdata?.name}&position=${formdata?.position}&company=${formdata?.company}&userid=${formdata?.user_id}&code=${formdata?.qr_code}`
                );
              } else {
              }
              setLoading(false);
            })
            .catch(function (error) {});

          // openInNewWindow(
          //   `/printcode?name=${data.firstname} ${data.lastname}&code=${data.qr_code}`
          // );

          setTimeout(() => props.onSuccess(), 1500);
        } else {
          setMsg('Failed to add user');
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setMsg('Something went wrong');
      });
  };

  const openInNewWindow = (url) => {
    const newWindow = window.open(url, '_blank', 'width=800,height=600');

    if (newWindow) {
      newWindow.onload = () => {
        setTimeout(() => {
          newWindow.print();
          newWindow.onafterprint = () => newWindow.close();
        }, 1000);
      };
    }
  };

  // 🔥 reusable input style
  const inputClass = (field) =>
    `w-full px-3 py-2 border rounded-lg outline-none transition
    ${
      errors[field]
        ? 'border-red-500 focus:ring-red-300'
        : 'border-gray-300 focus:ring-2 focus:ring-blue-400'
    }`;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/60 backdrop-blur-sm h-screen overflow-scroll py-5">
      <div className="bg-white w-full max-w-xl rounded-2xl shadow-xl p-6">
        <h2 className="text-2xl font-bold text-center mb-6">Add User</h2>

        {!success && (
          <div className="space-y-4">
            {/* GRID */}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <input
                  id="firstname"
                  placeholder="First Name"
                  onChange={handleChange}
                  className={inputClass('firstname')}
                />
                {errors.firstname && (
                  <p className="text-red-500 text-sm">{errors.firstname}</p>
                )}
              </div>

              <div>
                <input
                  id="lastname"
                  placeholder="Last Name"
                  onChange={handleChange}
                  className={inputClass('lastname')}
                />
                {errors.lastname && (
                  <p className="text-red-500 text-sm">{errors.lastname}</p>
                )}
              </div>
            </div>

            <div>
              <input
                id="company"
                placeholder="Company"
                onChange={handleChange}
                className={inputClass('company')}
              />
              {errors.company && (
                <p className="text-red-500 text-sm">{errors.company}</p>
              )}
            </div>

            <div>
              <input
                id="position"
                placeholder="Position"
                onChange={handleChange}
                className={inputClass('position')}
              />
              {errors.position && (
                <p className="text-red-500 text-sm">{errors.position}</p>
              )}
            </div>

            <div className="grid grid-cols-1 gap-4">
              <div>
                <input
                  id="country"
                  placeholder="Country"
                  onChange={handleChange}
                  className={inputClass('country')}
                />
                {errors.country && (
                  <p className="text-red-500 text-sm">{errors.country}</p>
                )}
              </div>

              <div>
                <div>
                  <input
                    id="phone"
                    placeholder="Phone"
                    onChange={handleChange}
                    className={inputClass('phone')}
                  />
                  {errors.phone && (
                    <p className="text-red-500 text-sm">{errors.phone}</p>
                  )}
                </div>
                <div className="flex items-center gap-2 mt-2">
  <input
    type="checkbox"
    onChange={() => handleDuplicate('phone')}
    checked={duplicate.phone}
  />
  <span className="text-sm">Phone allow duplicate (auto unique)</span>
</div>
              </div>
            </div>

            <div>
            <div>
              <input
                id="email"
                placeholder="Email"
                onChange={handleChange}
                className={inputClass('email')}
              />
              {errors.email && (
                <p className="text-red-500 text-sm">{errors.email}</p>
              )}
            </div>
            <div className="flex items-center gap-2 mt-2">
  <input
    type="checkbox"
    onChange={() => handleDuplicate('email')}
    checked={duplicate.email}
  />
  <span className="text-sm">Email allow duplicate (auto unique)</span>
</div>
            </div>

            <div>
              <select
                id="category"
                onChange={handleChange}
                className={inputClass('category')}>
                <option value="">Select Category</option>
                {CATEGORY_LIST.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
              {errors.category && (
                <p className="text-red-500 text-sm">{errors.category}</p>
              )}
            </div>

            {/* PRIVILEGES */}
            <div>
              <div className="font-semibold mb-2">Access Privileges</div>
              <div className="grid grid-cols-2 gap-2">
                {PRIVILEGES.map((item) => (
                  <label
                    key={item}
                    className="flex items-center gap-2 bg-gray-100 px-3 py-2 rounded-lg cursor-pointer hover:bg-gray-200">
                    <input
                      type="checkbox"
                      onChange={() => handleCheckbox(item)}
                      className="accent-blue-500"
                    />
                    {item}
                  </label>
                ))}
              </div>
              {errors.access_privilege && (
                <p className="text-red-500 text-sm">
                  {errors.access_privilege}
                </p>
              )}
            </div>
          </div>
        )}

        {/* MESSAGE */}
        {msg && (
          <div
            className={`mt-4 text-center font-semibold ${
              success ? 'text-green-500' : 'text-red-500'
            }`}>
            {msg}
          </div>
        )}

        {/* BUTTON */}
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={props.onClose}
            className="px-5 py-2 rounded-lg bg-gray-200 hover:bg-gray-300">
            Cancel
          </button>

          {!success && (
            <button
              onClick={handleSubmit}
              className="px-5 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700">
              {loading ? 'Loading...' : 'Confirm'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PopupAddUserNew;
